import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';

import QuizSubmitDisclaimer from './QuizSubmitDisclaimer';

const INPUT_NAME = 'buyer_profile_attributes.user_attributes.password';

export default function QuizPasswordQuestion({
  formErrors,
  formState,
  isValid,
  onChange,
  onSubmit
}) {
  const password = get(formState, INPUT_NAME) || '';
  const errors = formErrors[INPUT_NAME];

  return (
    <div className="AdoptionApplicationQuizPasswordQuestion">
      <FullPageQuizQuestion
        onSubmit={onSubmit}
        isValid={isValid}
        icon="lock"
        title="Enter a password — and you’re done!"
        subtitle="Log in to Good Dog with your email and password to save your info, chat with your breeder, and more."
      >
        <div className="mb6">
          <ErrorWrapper errors={errors}>
            <FullPageQuizTextInput
              type="password"
              name={INPUT_NAME}
              onChange={onChange}
              placeholder="6+ characters"
              value={password}
            />
          </ErrorWrapper>
        </div>
        <QuizSubmitDisclaimer />
      </FullPageQuizQuestion>
    </div>
  );
}

QuizPasswordQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formErrors: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  isValid: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
